module.exports = __webpack_public_path__ + "img/download_ico_white.805fe116.svg";